import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, Fragment as _Fragment } from "vue"
import _imports_0 from '@/assets/images/instalar-certificado-ssl.svg'


const _hoisted_1 = { class: "csr-signature-view container" }
const _hoisted_2 = { class: "breadcrumb-password-view pt-3 row" }
const _hoisted_3 = { class: "content-password-view" }
const _hoisted_4 = { class: "d-flex flex-row row" }
const _hoisted_5 = { class: "col-12 col-lg-6 text-start" }
const _hoisted_6 = { class: "mb-3" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { class: "d-flex justify-content-end mt-2" }
const _hoisted_9 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Breadcrumb = _resolveComponent("Breadcrumb")!
  const _component_TextArea = _resolveComponent("TextArea")!
  const _component_Icon = _resolveComponent("Icon")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Contact = _resolveComponent("Contact")!
  const _component_Loading = _resolveComponent("Loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_Breadcrumb, { "path-list": {
          'Guia de instalação SSL': 'ssl-certificate/installation-guide-ssl',
          'Downolad de Certificado Digital com CSR': '',
        } })
      ]),
      _cache[11] || (_cache[11] = _createElementVNode("div", { class: "title text-start" }, [
        _createElementVNode("h2", { class: "fw-600" }, " Instalação de Certificado Digital Financeiro e SSL com CSR ")
      ], -1)),
      _cache[12] || (_cache[12] = _createElementVNode("div", { class: "subtitle text-start" }, [
        _createElementVNode("p", { class: "fs-6" }, " Preencha os campos abaixo para finalizar o processo de emissão e instalar seu Certificado Digital. ")
      ], -1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _cache[10] || (_cache[10] = _createElementVNode("div", { class: "col-12 col-lg-6 d-none d-lg-block text-center" }, [
            _createElementVNode("img", {
              src: _imports_0,
              alt: "emitir-certificado"
            })
          ], -1)),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("strong", null, " Usuário: " + _toDisplayString(_ctx.sslCertificate.user || ''), 1)
            ]),
            _createVNode(_component_TextArea, {
              modelValue: _ctx.model.csr,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.model.csr) = $event)),
              class: "mb-2",
              label: "CSR",
              rows: "4",
              "is-required": true,
              size: "160",
              resizable: false,
              placeholder: "Cole aqui o CSR",
              "error-log": _ctx.errors.csr
            }, null, 8, ["modelValue", "error-log"]),
            _createVNode(_component_router_link, {
              class: "link-info mb-5",
              to: "/faq/generate-csr-request",
              target: "_blank"
            }, {
              default: _withCtx(() => [
                _cache[4] || (_cache[4] = _createElementVNode("span", { class: "me-2" }, "Instruções para gerar CSR", -1)),
                _createVNode(_component_Icon, { name: "arrow-up-right-from-square" })
              ]),
              _: 1
            }),
            (_ctx.hastermDigitalHash)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  _cache[7] || (_cache[7] = _createElementVNode("strong", null, "Você também precisará assinar o Termo Digital.", -1)),
                  _cache[8] || (_cache[8] = _createElementVNode("p", null, " Faça download do hash do Termo e cole a assinatura no campo abaixo ", -1)),
                  _createVNode(_component_router_link, {
                    class: "link-info mb-5",
                    to: "/faq/sign-digital-term",
                    alt: "faq"
                  }, {
                    default: _withCtx(() => [
                      _cache[5] || (_cache[5] = _createElementVNode("span", { class: "me-2" }, " Instruções para Assinar o Termo Digital", -1)),
                      _createVNode(_component_Icon, { name: "arrow-up-right-from-square" })
                    ]),
                    _: 1
                  }),
                  _createElementVNode("button", {
                    class: "btn btn-outline-primary col-12 col-lg-10 col-xl-7 mb-5",
                    type: "button",
                    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.downloadHash && _ctx.downloadHash(...args)))
                  }, [
                    _createVNode(_component_Icon, {
                      class: "me-2",
                      name: "download"
                    }),
                    _cache[6] || (_cache[6] = _createElementVNode("span", null, " Download do hash do Termo Digital", -1))
                  ]),
                  _createVNode(_component_TextArea, {
                    id: "csr",
                    modelValue: _ctx.model.signedHash,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.model.signedHash) = $event)),
                    name: "csr",
                    class: "mb-5",
                    label: "Assinatura do Termo Digital",
                    rows: "6",
                    "is-required": true,
                    size: "160",
                    resizable: false,
                    placeholder: "Insira aqui o hash do Termo Digital assinado",
                    "error-log": _ctx.errors.signedHash
                  }, null, 8, ["modelValue", "error-log"])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("button", {
                id: "emit-certificate-button",
                class: _normalizeClass(["btn", !_ctx.isValid ? 'btn-secondary' : 'btn-primary']),
                type: "button",
                disabled: _ctx.isDisaled,
                onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.handleSubmit && _ctx.handleSubmit(...args)))
              }, [
                _cache[9] || (_cache[9] = _createElementVNode("span", null, " Emitir Certificado ", -1)),
                _createVNode(_component_Icon, {
                  class: "ms-2",
                  name: "shield"
                })
              ], 10, _hoisted_9)
            ])
          ])
        ]),
        _createVNode(_component_Contact)
      ])
    ]),
    _createVNode(_component_Loading, { "is-loading": _ctx.isLoading }, null, 8, ["is-loading"])
  ], 64))
}